import classNames from 'clsx';
import React, { type ReactEventHandler, useCallback } from 'react';
import { TariffSwitch } from 'reactApp/ui/TariffCardNew/components/TariffSwitch';
import type { SwitchOption } from 'reactApp/ui/TariffCardNew/components/TariffSwitch.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './TariffPeriodSwitch.css';

const switchOptions: [SwitchOption, SwitchOption] = [
    {
        value: ETabsName.month,
        text: 'На месяц',
    },
    {
        value: ETabsName.year,
        text: 'На год',
    },
];

interface TariffPeriodSwitchProps {
    checkedOption: ETabsName;
    onClickSwitch: (tab: ETabsName) => void;
}

export const TariffPeriodSwitch = ({ checkedOption, onClickSwitch }: TariffPeriodSwitchProps) => {
    const onTariffSwitchClick: ReactEventHandler = useCallback(
        (event) => {
            event.stopPropagation();
            onClickSwitch(checkedOption === ETabsName.year ? ETabsName.month : ETabsName.year);
        },
        [checkedOption, onClickSwitch]
    );
    const containsDarkTheme = isDarkThemeModeEnabled();
    return (
        <div className={styles.root}>
            <div className={classNames(styles.discountLabel, { [styles.darkLabel]: containsDarkTheme })} />
            <TariffSwitch
                gray
                sizeExtraSmall
                checked={checkedOption === ETabsName.year}
                onClick={onTariffSwitchClick}
                options={switchOptions}
            />
        </div>
    );
};
